import React, { useEffect } from "react";
import ReactEChartsCore from "echarts-for-react/lib/core";
import * as echarts from "echarts/core";
import { Card } from "primereact/card";
import "./style.css";

const colors = {
  0: "#145EFC",
  1: "#145EFC",
  2: "#145EFC",
  3: "#145EFC",
  4: "#145EFC",
  5: "#145EFC",
  6: "#145EFC"
};
const calculatePercentage = (value, total) => {
  return parseFloat((value / total) * 100).toFixed(2) + "%";
};
const HorizontalBar = ({ data }) => {
  const totalEmployees = data[0]?.value;

  const option = {
    title: {
      text: "Acknowledgements as per Submission Date"
    },
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "shadow"
      }
    },
    grid: {
      left: "25",
      right: "10",
      bottom: "10",
      containLabel: true
    },
    xAxis: {
      type: "value",
      boundaryGap: [0, 0.01]
    },
    yAxis: {
      type: "category",
      data: data.map(item => `${item.name}`).reverse(),
      
      axisLabel: {
        margin: 5,
        fontSize: 11
      }
    },

    series: [
      {
        type: "bar",
        data: data.map(item => item.value).reverse(),
        itemStyle: {
          color: function (param) {
            console.log(param);
            return colors[param.dataIndex];
          }
        }
      }
    ]
  };

  return (
    <Card>
      <ReactEChartsCore
        echarts={echarts}
        className="chart-barss"
        option={option}
        notMerge={true}
        lazyUpdate={true}
        theme={"theme_name"}
        opts={{}}
      />
    </Card>
  );
};

export default HorizontalBar;
